export default __webpack_public_path__ + "assets/sounds/7f4ed871b28fbd94af5ea23d0a0d02b4.mp3";